import { Encyclopedia } from '.';
import { PetSpecies } from '../buruburu/pet';
import { SpeciesState } from './encyclopedia.schema';

export const encyclopediaModifiers = ({
  encyclopedia,
}: Encyclopedia.MutableState) => ({
  setSpeciesState: (species: PetSpecies, state: SpeciesState) => {
    const currentState = encyclopedia.speciesState[species];

    // Already unlocked, do nothing.
    if (currentState === 'unlocked') return;
    // Cannot veil an unveiled species, do nothing.
    if (currentState === 'unveiled' && state === 'veiled') return;

    encyclopedia.speciesState[species] = state;

    // Unlocking a species, set notification.
    if (state === 'unlocked') {
      encyclopedia.speciesNotification[species] = true;
    }
  },
});
